import { localized } from "@msuite/ui/localization";
import { createColumnHelper } from "@msuite/ui/table";
import { createdAtFormatter } from "@msuite/utils/date";
import { guardString } from "@msuite/utils/strings";
import type { RiskAssessmentAcknowledgementListItem } from "@msuite/utils/types";

export const columnHelper = createColumnHelper<RiskAssessmentAcknowledgementListItem>();

export const columns = [
	columnHelper.accessor((row) => createdAtFormatter(row.acknowledgement), {
		id: "createdAt",
		header: localized("general_fields.created_at"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("file.fileName", {
		id: "fileName",
		header: localized("files.file_name"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("acknowledgement.ipAddress", {
		id: "ipAddress",
		header: "IP",
		cell: (cell) => guardString(cell.getValue()),
	}),
];
